export const ACTION_LIST_USERS = "ACTION_LIST_USERS";
export const ACTION_DETAIL_USER = "ACTION_DETAIL_USER";
export const ACTION_CREATE_USER = "ACTION_CREATE_USER";
export const ACTION_UPDATE_USER = "ACTION_UPDATE_USER";
export const ACTION_LIST_TYPES_IDENTIFICATION = "ACTION_LIST_TYPES_IDENTIFICATION";
export const ACTION_LIST_GENDERS = "ACTION_LIST_GENDERS";
export const ACTION_LIST_CIVIL_STATUS = "ACTION_LIST_CIVIL_STATUS";
export const ACTION_LIST_TYPES_EPS = "ACTION_LIST_TYPES_EPS";
export const ACTION_LIST_TYPES_AFP = "ACTION_LIST_TYPES_AFP";
export const ACTION_LIST_TYPES_ARL = "ACTION_LIST_TYPES_ARL";
export const ACTION_LIST_TYPES_CCF = "ACTION_LIST_TYPES_CCF";
export const ACTION_DIALOG_ACTIVE = "ACTION_DIALOG_ACTIVE";
export const ACTION_DEFAULT_TYPE_IDENTIFICATION = "ACTION_DEFAULT_TYPE_IDENTIFICATION";
export const ACTION_GET_DETAIL_USER = "ACTION_GET_DETAIL_USER";
export const ACTION_INITIAL_DETAIL_USER = "ACTION_INITIAL_DETAIL_USER";
export const ACTION_LIST_TYPES_PRODUCTS = "ACTION_LIST_TYPES_PRODUCTS";
export const ACTION_ASSOCIATE_PRODUCT = "ACTION_ASSOCIATE_PRODUCT";
export const ACTION_LIST_TYPES_CONTRACTS = "ACTION_LIST_TYPES_CONTRACTS";
export const ACTION_LIST_TYPES_BENEFITS = "ACTION_LIST_TYPES_BENEFITS";
export const ACTION_LIST_PRODUCTS = "ACTION_LIST_PRODUCTS";
